import baseAxiosInstance from 'utils/BaseApi';

export class CasesService {
  private casesBase = '/candidate/v1/support-cases';

  private static currentInstance: CasesService;

  private constructor() {}

  static createInstance(): CasesService {
    return new CasesService();
  }

  static getInstance(): CasesService {
    if (!this.currentInstance) this.currentInstance = this.createInstance();
    return this.currentInstance;
  }

  getCases = (travelerId: number, placementId?: string, status?: string) => {
    const params: Record<string, string> = {};
    if (placementId) params.placementId = placementId;
    if (status) params.status = status;
    return baseAxiosInstance.get(`${this.casesBase}/${travelerId}`, { params });
  };

  getCaseDetail = (sfCaseId: string) =>
    baseAxiosInstance.get(`${this.casesBase}/detail/${sfCaseId}`);
}
